import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { t } from "i18next";

export function usePromoCode(initialPromoCode?: string) {
  const [urlSearchParams] = useSearchParams();
  const [promoCode, setPromoCode] = useState<string>(
    initialPromoCode ?? urlSearchParams.get("code") ?? "",
  );
  const [appliedPromoCode, setAppliedPromoCode] = useState<string>(
    initialPromoCode ?? urlSearchParams.get("code") ?? "",
  );

  const [isPromoValid, setIsPromoValid] = useState(true);
  const [promoValidationError, setPromoValidationError] = useState<string>();

  useEffect(() => {
    if ((!promoCode && !appliedPromoCode) || appliedPromoCode === promoCode) {
      setIsPromoValid(true);
      setPromoValidationError(undefined);
      return;
    }
    const timeout = setTimeout(() => {
      setIsPromoValid(false);
      setPromoValidationError(
        t("components.payments.subscription.applyPromoToComplete"),
      );
    }, 400);
    return () => clearTimeout(timeout);
  }, [promoCode, appliedPromoCode]);

  return {
    promoCode,
    appliedPromoCode,
    isPromoValid,
    promoValidationError,
    setPromoCode,
    setAppliedPromoCode,
  };
}
